import React from 'react'

const TextArea = ({ onChange, onKeyDown, placeholder, value }) => {
    return (
        <textarea
            autoFocus
            className="flex w-full resize-none items-center outline-none"
            onChange={onChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            value={value}
        />
    )
}

export default TextArea
